import { useMethod } from '../../../../lib/hooks';
import { scopeMembershipFingerprint } from '../../lib/scopeFilter';
import type { HotelAvailability, HotelPayload } from './hotelTypes';

function scopeArg(regionFilter: string | null): string | null {
  return !regionFilter || regionFilter === 'all' ? null : regionFilter;
}

/** `group:current-selection` keeps its key while its venues change. */
function scopeKey(regionFilter: string | null): string {
  const membership = scopeMembershipFingerprint(regionFilter);
  return membership ? `${regionFilter}|${membership}` : regionFilter || 'all';
}

/** The Hotel section's payload for the scope (one warehouse read, cached). */
export function useHotel(
  restaurantId: string | undefined,
  regionFilter: string | null,
  enabled: boolean,
) {
  return useMethod<HotelPayload>(
    'opsCommand/getHotel',
    restaurantId && enabled ? [restaurantId, scopeArg(regionFilter)] : null,
    {
      refreshInterval: 30 * 60_000,
      // A scope change must not keep showing the previous hotel.
      keepPreviousData: false,
      keyExtra: scopeKey(regionFilter),
    },
  );
}

/** Whether a venue in scope has a hotel (PMS stays): the nav shows Hotel then. */
export function useHotelAvailability(
  restaurantId: string | undefined,
  regionFilter: string | null,
) {
  return useMethod<HotelAvailability>(
    'opsCommand/getHotelAvailability',
    restaurantId ? [restaurantId, scopeArg(regionFilter)] : null,
    {
      keepPreviousData: true,
      keyExtra: scopeKey(regionFilter),
    },
  );
}
